// @flow
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

export default graphql(
  gql`
    mutation upvote($id: ID!) {
      upvoteProposal(id: $id) {
        id
        title
        createdAt
        isUpvoted
        totalUpvotes
        user {
          id
          firstName
          lastName
        }
      }
    }
  `,
  {
    name: 'upvote',
  }
);



// WEBPACK FOOTER //
// ./src/pages/feed/graphql/upvote.js